import { useCallback, useEffect, useRef } from 'react';

export interface UseIntervalProps {
    handler: () => void;
    timeout?: number;
    isEnabled?: boolean;
}

export const useInterval = ({ handler, timeout, isEnabled = true }: UseIntervalProps) => {
    const savedHander = useRef(handler);
    const intervalId = useRef<number | null>(null);

    useEffect(() => {
        savedHander.current = handler;
    }, [handler]);

    const setIntervalIfEnabled = useCallback(() => {
        if (timeout && isEnabled) {
            intervalId.current = window.setInterval(tick, timeout);
        }
    }, [timeout, isEnabled]);

    useEffect(() => {
        setIntervalIfEnabled();
        return clearIntervalIfExists;
    }, [timeout, isEnabled, setIntervalIfEnabled]);

    const tick = () => savedHander.current();

    const clearIntervalIfExists = () => {
        if (intervalId.current) {
            window.clearInterval(intervalId.current);
        }
    };

    const resetInterval = () => {
        clearIntervalIfExists();
        setIntervalIfEnabled();
    };

    return resetInterval;
};
